module.exports = __webpack_public_path__ + "1e29f2931a14709b976ccd0f928f360d.png";